module.exports = __webpack_public_path__ + "static/media/webdesign-services-img60.c58b2e4c.jpg";